import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { SubmitButton } from "@/components/common";

type Props = {
  onClick: () => void;
  ["data-test-id"]?: string;
};

export const SaveFilterConfigButton: FC<Props> = ({ onClick, "data-test-id": dataTestId }: Props) => {
  const { t } = useTranslation();

  return (
    <SubmitButton onClick={onClick} style={{ height: "24px", padding: "0 7px" }} data-test-id={dataTestId}>
      {t("save_current_search_condition")}
    </SubmitButton>
  );
};
